module.exports = __webpack_public_path__ + "static/media/icon-sidebar-comm.8e3d2c2f.svg";